module.exports = __webpack_public_path__ + "img/icon-wmx.dbf92c06.png";